/* eslint no-unused-vars: 0 */
import * as daterangepicker from 'daterangepicker';
import moment from 'moment';

import Base from 'app/views/base';

import { PAGE_SELECTOR } from 'app/routers/account_router';

import tmpl from 'templates/datepicker_range';

export const MIN_DATE = '2013-01-01';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'click .down-arrow': 'clickInput',
  },

  initialize({ label, minDate }) {
    this.label = label;
    this.minDate = minDate;
  },

  context() {
    return { label: this.label };
  },

  afterRender() {
    this.setupDatepickers();
  },

  setupDatepickers() {
    /*
      `.format()` is used all over this method because of odd UI bugs:
      github.com/dangrossman/bootstrap-daterangepicker/issues/1058
      github.com/dangrossman/bootstrap-daterangepicker/issues/343
    */
    const self = this;
    this.$('form input').daterangepicker({
      locale: { format: 'YYYY/MM/DD' },
      startDate: this.model.get('startDatetime'),
      endDate: this.model.get('endDatetime'),
      minDate: this.minDate || MIN_DATE,
      maxDate: moment().utc().format(),
      alwaysShowCalendars: true,
      showCustomRangeLabel: false,
      showDropdowns: true,
      ranges: {
        Today: [moment().utc().startOf('day').format(), moment().utc().endOf('day').format()],
        Yesterday: [moment().utc().startOf('day').subtract(1, 'days').format(), moment().utc().subtract(1, 'days').endOf('day').format()],
        'Last 7 Days': [moment().utc().startOf('day').subtract(6, 'days').format(), moment().utc().endOf('day').format()],
        'Last 30 Days': [moment().utc().startOf('day').subtract(29, 'days').format(), moment().utc().endOf('day').format()],
        'Last 31 Days': [moment().utc().startOf('day').subtract(30, 'days').format(), moment().utc().endOf('day').format()],
        'Last Month': [moment().utc().startOf('day').subtract(1, 'months').add(1, 'days').format(), moment().utc().endOf('day').format()],
      },
      linkedCalendars: false,
      autoApply: true,
      parentEl: PAGE_SELECTOR,
      opens: 'center',
      applyClass: 'btn-blue',
    }, (start, end) => {
      const endDatetime = moment.utc(end.format('YYYY-MM-DD')); // comes in as local tz
      self.model.set({ startDatetime: start, endDatetime });
    });
  },

  clickInput() {
    this.$('input').click();
  },
});



// WEBPACK FOOTER //
// ./app/views/datepicker_range_view.js